module.exports = __webpack_public_path__ + "img/885.c714ee29.png";